<template>
  <div class="calender-container">
    <flat-pickr v-model="date" :name="name" :placeholder="placeholder" :ref="name" :config="config"
                :class="additionalCss" autocomplete="off" :style="formSize"></flat-pickr>
    <div :class="calIconButtonCss" @click="calenderOpen"><i class="far fa-calendar-alt"></i></div>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import 'flatpickr/dist/themes/airbnb.css';
import {Japanese} from 'flatpickr/dist/l10n/ja';

export default {
  props: ['name', 'default', 'isDisable', 'isError', 'size'],
  components: {
    flatPickr
  },
  data () {
    return {
      value: null,
      config: {
        locale: Japanese,
        static: true,
        allowInput: true,
        altFormat: 'Y/n/j(D)',
        minDate: '2010/1/1',
        maxDate: '2040/12/31'
      },
      placeholder: ''
    };
  },
  watch: {
    default: function () {
      this.initialize();
    }
  },
  mounted: function () {
    this.initialize();
  },
  computed: {
    date: {
      get () {
        return this.value;
      },
      set (value) {

        let storeValue = {key: this.name, value: value};

        this.$store.dispatch('formValues/setFormData', storeValue);

        this.value = value;
      }
    },
    calIconButtonCss: function () {

      if (this.isDisable) {
        return 'cal-icon-button-disable';
      } else {
        return 'cal-icon-button';
      }
    },
    additionalCss: function () {
      let css = ['flatpickr-input'];

      if (this.isError) {
        css.push('is-error');
      }

      if (this.isDisable) {
        css.push('cal-form-disable');
      } else {
        css.push('cal-form');
      }

      return css;
    },
    formSize: function () {

      let size = parseInt(this.size);
      // console.log(size);

      if (isNaN(size)) {
        return 'width: 120px';
      } else {
        return 'width:' + size + 'px';
      }
    },
  },
  methods: {
    initialize: function () {

      let now = new Date();

      let y = now.getFullYear();
      let m = now.getMonth() + 1;
      let d = now.getDate();

      if (m < 10) {
        m = '0' + m;
      }
      if (d < 10) {
        d = '0' + d;
      }

      this.placeholder = y + '-' + m + '-' + d;

      let value = {key: this.name, value: this.default};

      this.$store.dispatch('formValues/setFormData', value);

      this.value = this.default;

    },
    calenderOpen: function () {
      let ref = this.$refs[this.name];
      ref.$el.focus();
    }
  }
};
</script>

<style lang="scss" scoped>
  .calender-container {
    display: flex;
    align-items: center;
  }

  /* flatpickrで利用 */
  .flatpickr-input {
    display: inline-block;
    border: solid 1px #979797;
    border-radius: 4px;
    font-size: 16px;
    height: 36px;
    line-height: 36px;
    padding-left: 15px;
    background: #fff;
  }

  .cal-icon-button-disable,
  .cal-icon-button {
    margin-left: 8px;
    display: inline-block;
    height: 30px;
    width: 30px;
    background: #aaa;
    border-radius: 4px;
    text-align: center;
    line-height: 30px;
    font-size: 16px;
    color: #fff;
  }

  .cal-icon-button {
    cursor: pointer;
  }

  .cal-icon-button-disable {
    background: #ddd;
  }

  .cal-icon-button:active {
    box-shadow: inset 0 2px 3px 0 rgba(0, 0, 0, 0.5);
    opacity: 0.5;
    background: #ccc;
  }

  .cal-icon-button:hover {
    background: #ccc;
  }

  /** use computed */
  .cal-form-disable {
    font-size: 14px;
    background: #f8f8f8;
  }

  .is-error {
    border: 1px solid #DD4B39;
    background: rgba(237, 159, 150, 0.28);
    color: #DD4B39;
  }

  .cal-form {
    font-size: 14px;
  }

</style>
